;(function() {
	// detect device type
	var isTouchDevice = /Windows Phone/.test(navigator.userAgent) || ('ontouchstart' in window) || window.DocumentTouch && document instanceof DocumentTouch;

	if (isTouchDevice) {
		document.documentElement.classList.add('is-touch-device');
	} else {
		document.documentElement.classList.add('is-not-touch-device');
	}

}());